import _ from '@lodash';
import { Avatar, Paper, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from "react";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    divProfile: {
        //background: 'linear-gradient(to right, ' + theme.palette.primary.dark + ' 0%, ' + theme.palette.primary.main + ' 100%)',
        height: "auto",
        minHeight: 120,
    },
    textColor: {
        color: theme.palette.type === 'dark' ? '#CCC' : '#666',
    }
});

class Produto extends XAPPComponent {

    render() {
        const { data, classes, xappRouteParams, idagendamento = null } = this.props;
        return (
            <Paper className={clsx(classes.divProfile, "flex items-center justify-center w-full md:justify-start mt-8")}>
                <Avatar className="w-96 h-96 ml-12" src={data.foto ? data.foto : "assets/images/avatars/profile.png"} />
                <div className="flex w-full items-center">
                    <div className="flex w-full flex-col items-start">
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{data.nome}</Typography>
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{"Valor: " + (!_.isUndefined(data.valordescricao) && !_.isNull(data.valordescricao) ? data.valordescricao : "")}</Typography>
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{"Descrição: " + (!_.isUndefined(data.descricaocomercial) && !_.isNull(data.descricaocomercial) ? data.descricaocomercial : "")}</Typography>
                        <Typography className={clsx(classes.textColor, "mx-16")} color="textSecondary">{"Orientações: " + (!_.isUndefined(data.orientacao) && !_.isNull(data.orientacao) ? data.orientacao : "")}</Typography>
                    </div>
                </div>
            </Paper>
        )
    }
}

export default withStyles(styles, { withTheme: true })(Produto);